import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'src/store/redux';

import { LanguageState, LanguageStateResponse } from './types';

export const clientStateApi = createApi({
  reducerPath: 'client-state',
  baseQuery: baseQuery('clientState'),
  endpoints: (builder) => ({
    getLanguageState: builder.query<LanguageState, string>({
      query: (userBk) => {
        return `${userBk}/languageState`;
      },
      transformResponse: (response: LanguageStateResponse) => {
        if (!response) return {};

        return response;
      },
    }),
  }),
});

export const { useGetLanguageStateQuery } = clientStateApi;
